import { render, staticRenderFns } from "./Starter.vue?vue&type=template&id=3f7ed65c&scoped=true"
import script from "./Starter.vue?vue&type=script&lang=js"
export * from "./Starter.vue?vue&type=script&lang=js"
import style0 from "./Starter.vue?vue&type=style&index=0&id=3f7ed65c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7ed65c",
  null
  
)

export default component.exports